import { Close } from "@mui/icons-material";
import { Box, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, TextField } from "@mui/material";
import React, { useState } from "react";
import { CustomButton } from "src/Components/Common/Button/CustomButton";
import LoadingIcon from "src/Components/Common/LoadingIcon";
import { DIALOG_MAX_WIDTHS } from "src/Components/Common/Modal/ModalWidth";

const VendorPortalFeedbackModal = ({ openFeedback, setOpenFeedback }) => {
  const [isLoadingSubmit, setIsLoadingSubmit] = useState(false);
  const [feedBackText, setFeedBackText] = useState("");
  const handleClose = () => {
    setOpenFeedback(false);
    setFeedBackText("");
    setIsLoadingSubmit(false);
  };
  const handleSubmit = () => {
    // Handle the submit action
  };
  return (
    <>
      <Dialog open={openFeedback} maxWidth={DIALOG_MAX_WIDTHS.MD} fullWidth>
        <DialogTitle className="dialog-title">
          <div className="heading-m">Feedback</div>
          <div className="vertical_center_align">
            <IconButton onClick={handleClose}>
              <Close />
            </IconButton>
          </div>
        </DialogTitle>
        <DialogContent dividers sx={{ p: 2 }}>
          <Box>
            <TextField
              fullWidth
              multiline
              maxRows={4}
              variant="outlined"
              placeholder="Please share your feedback regarding the issues you face during ledger reconciliaton."
              value={feedBackText}
              onChange={(e) => setFeedBackText(e.target.value)}
            />
          </Box>
        </DialogContent>

        <DialogActions className="dialog-actions">
          <CustomButton size="medium" colorToken="violet" variant="text" onClick={handleClose}>
            Cancel
          </CustomButton>
          <CustomButton
            size="medium"
            colorToken="violet"
            variant="contained"
            disabled={!feedBackText || isLoadingSubmit}
            startIcon={<LoadingIcon loading={isLoadingSubmit} />}
            onClick={handleSubmit}
          >
            Submit Feedback
          </CustomButton>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default VendorPortalFeedbackModal;
